import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const dpiLocaleModule: LocaleModule = {
  name: "dpi",
  messages: { en: en, it: it },
};
